import ToastHighLighter from '@/lib/ToastHighLighter';

export const FooterIconsCode = () => {
  const language = 'html';
  const codeString = `
// Footer share icons
<ul class="social__icons">
 <!-- Instagram -->
 <li>
  <a href="https://www.fhnw.ch" target="_blank" title="Folgen Sie uns auf Instagram" class="icon__instagram--sm"></a>
 </li>

 <!-- Facebook -->
 <li>
  <a href="https://facebook.com/fhnw.ch" target="_blank" title="folgen Sie uns auf Facebook" class="icon__facebook--sm"></a>
 </li>

 <!-- Bluesky -->
 <li>
  <a href="https://bsky.app/profile/fhnw.ch" target="_blank" title="folgen Sie uns auf Bluesky" class="icon__bluesky--sm"></a>
 </li>

 <!-- Xing -->
 <li>
  <a href="https://www.xing.com/companies/fachhochschulenordwestschweiz/" target="_blank" title="folgen Sie uns auf Xing" class="icon__xing--sm"></a>
 </li>

 <!-- LinkedIn -->
 <li>
  <a href="https://www.linkedin.com/school/fachhochschule-nordwestschweiz-fhnw/" target="_blank" title="folgen Sie uns auf LinkedIn" class="icon__linkedin--sm"></a>
 </li>

 <!-- Youtube -->
 <li>
  <a href="https://www.fhnw.ch" target="_blank" title="folgen Sie uns auf YouTube" class="icon__youtube--sm"></a>
 </li>

 <!-- Vimeo -->
 <li>
  <a href="https://www.fhnw.ch" target="_blank" title="folgen Sie uns auf Vimeo" class="icon__vimeo--sm"></a>
 </li>

 <!-- Flickr -->
 <li>
  <a href="https://www.fhnw.ch" target="_blank" title="folgen Sie uns auf Flickr" class="icon__flickr--sm"></a>
 </li>

 <!-- Issuu -->
 <li>
  <a href="https://www.fhnw.ch" target="_blank" title="folgen Sie uns auf Issuu" class="icon__issuu--sm"></a>
 </li>
</ul>
  `;

  return (
    <>
      <ToastHighLighter
        name={'icons'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
